
import { MongoView, MongoViewTypes } from "@/models/mongo-view";
import { MongoViewService } from "@/services/mongo-view-service";
import Vue from "vue";
import AppMongoViewEdit from "@/components/mongoviews/MongoViewEdit.vue";
import { IAvailableMongoViewColumn } from "@/utils/mongo-view/mongo-view-column";
import { getPriceListViewColumns } from "@/utils/price-list/price-list-view-columns";

export default Vue.extend({
	data(){
		return {
			views: [] as MongoView[],
			toEditView: null as null | MongoView
		};
	},
	computed: {
		availableColumns():IAvailableMongoViewColumn[]{
			return getPriceListViewColumns();
		}
	},
	methods: {
		createView(){
			let view = new MongoView();
			view.Type = MongoViewTypes.PRICE_LISTS;
			this.toEditView = view;
		},
		editView(view:MongoView){
			this.toEditView = new MongoView(view.getJSON());
		},
		async deleteView(view:MongoView){
			let text = this.$ct("are-you-sure-you-want-to-delete-view", {name: view.Name});
			let confirm = await this.$wf.confirm(text, this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "warning");
			if (!confirm) return;
			await MongoViewService.deleteView(view);
			this.refresh();
		},
		async refresh(){
			this.views = await MongoViewService.getByType(MongoViewTypes.PRICE_LISTS);
		},
		close(){
			this.$emit("close");
		},
		onViewEditClose(){
			this.toEditView = null;
			this.refresh();
		}
	},
	async created(){
		await this.refresh();
	},
	components: {
		AppMongoViewEdit
	},
	i18nEx: {
		componentPrefix: "components.price-lists"
	}
});
